import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import InternalTemplate from '../../../../../components/templates/internal';
import {IBalanceDetail} from '../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../navigators';
import {BalanceListItem} from './item';
import {SpinnerModal} from '../../../../../components/modals';
import {EmptyListIcon} from '../../../../../components/icons';
import HeaderBox from './header-box';
import {useBalanceList} from './hooks/balance-list.hook';
import {useMainProperties} from '../../../../../hooks/app/useMainProperties';

type ScreenProps = NativeStackScreenProps<StackParamList, 'BalanceList'>;

const ClientBalanceListScreen = ({navigation}: ScreenProps) => {
  const [filtered, setFiltered] = useState([] as IBalanceDetail[]);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {balanceList, fetchBalanceList, customer} = useBalanceList();

  const {isSalesMan} = useMainProperties();

  const getList = async () => {
    setIsLoading(true);
    setFiltered([]);
    await fetchBalanceList();
    setIsLoading(false);
  };

  useEffect(() => {
    if (balanceList) {
      setFiltered(balanceList);
    } else {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceList]);

  useEffect(() => {
    if (customer) {
      setFiltered([]);
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  const handleGoBack = () => {
    if (isSalesMan()) {
      navigation.popTo('SalesmanClientDashboard');
    } else {
      navigation.popToTop();
    }
  };

  const handleSelectItem = (index: number) => {
    navigation.navigate('BalanceDetail', filtered[index]);
  };

  const handleSearchChange = (value: string) => {
    const search = value.trim().toLowerCase();
    setSearchText(search);

    if (search === '') {
      if (balanceList) {
        setFiltered(balanceList);
      }

      return;
    }

    if (balanceList) {
      const result = balanceList.filter(balance => {
        if (balance.id && balance.id.toLowerCase().indexOf(search) > -1) {
          return true;
        }
        if (
          balance.type &&
          balance.type.label.toLowerCase().indexOf(search) > -1
        ) {
          return true;
        }
        if (
          balance.summary &&
          balance.summary.toLowerCase().indexOf(search) > -1
        ) {
          return true;
        }
      });
      setFiltered(result);
    }
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const showContent = () => {
    if (isLoading) {
      return <></>;
    }
    if (balanceList?.length === 0) {
      return <EmptyListIcon />;
    }
    if (filtered) {
      return filtered.map((balance: IBalanceDetail, index: number) => (
        <BalanceListItem
          key={`balance-item-${index}`}
          id={balance.id}
          type={balance.type}
          summary={balance.summary}
          amount={balance.amount}
          onPress={() => handleSelectItem(index)}
          rowType={isOdd(index) ? 'odd' : 'even'}
        />
      ));
    }

    return <></>;
  };

  return (
    <InternalTemplate
      title={'screen-balance-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box paddingX={5}>
        <HeaderBox
          onChangeSearch={handleSearchChange}
          count={filtered.length}
          searchText={searchText}
        />
      </Box>
      <Box marginBottom={20}>{showContent()}</Box>
    </InternalTemplate>
  );
};
export default ClientBalanceListScreen;
